import styled, { css } from 'styled-components';
import { blockTokens } from '../../tokens/components/Block/tokens';

export const BlockBodyWrapper = styled.div`
  padding: ${blockTokens.CoreSpacingBox};
`;

export const BlockWrapper = styled.div`
  background-color: ${blockTokens.CoreBackgroundColorDefault};
  border: ${blockTokens.CoreBorderStyle};
  border-radius: ${blockTokens.CoreBorderRadius};
  margin-bottom: ${blockTokens.CoreSpacingBox};

  &::after,
  &::before {
    clear: both;
    content: '';
    display: table;
  }

  ${({ theme }) =>
    theme.transparent &&
    css`
      background-color: ${blockTokens.CoreBackgroundColorTransparent};
      border: none;
    `}

  ${({ theme }) =>
    theme.trim &&
    css`
      margin-bottom: 0;
    `}

  ${({ theme }) =>
    theme.modal &&
    css`
    box-shadow: none;
    margin-bottom: 0;

    ${
      theme.mobile &&
      css`
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        margin: 0 auto;
        position: fixed;

        ${BlockBodyWrapper} {
          flex: 1;
          overflow: scroll;
        }
      `
    }}
  `}
`;
